/* global teacherName */

import { isUserTheTeacher } from '../utils/userUtils.js';

export function getProjectTwitterText(options) {
    let userIsTeacherText;
    if (options && options.hasAutoDonationMatch) {
        userIsTeacherText = 'Donations to my classroom are currently being matched! ';
    } else {
        userIsTeacherText = "Check out my classroom on @DonorsChoose! I'd love your help to bring my project to life: ";
    }
    const userIsNotTeacherText = 'I love this teacher\'s idea for helping students: ';
    return getConciseShareText(options, userIsTeacherText, userIsNotTeacherText);
}

export function getTeacherStatTwitterText(options) {
    const text = "Thank you for supporting my classroom on DonorsChoose! Check out the milestones you've helped me accomplish via @DonorsChoose! ";
    return getConciseShareText(options, text, text);
}

export function getTeacherStatsSMSText(options) {
    const text = "Here's what I'm celebrating today - my DonorsChoose milestones! I'm really proud of this and wanted to share: ";
    return getConciseShareText(options, text, text);
}

export function getTeacherProfileTwitterText(options) {
    const userIsTeacherText = 'Check out my classroom on @DonorsChoose! ';
    const userIsNotTeacherText = 'See ' + teacherName + '\'s classroom projects on @DonorsChoose: ';

    return getConciseShareText(options, userIsTeacherText, userIsNotTeacherText);
}

function getConciseShareText(options, userIsTeacherText, userIsNotTeacherText) {
    let text;
    if (options && options.isUserTheTeacher) {
        text = userIsTeacherText;
    } else {
        text = userIsNotTeacherText;
    }
    if (options && options.stripHandle) {
        text = text.replace(/@DonorsChoose/g, 'DonorsChoose');
    }
    return encodeURIComponent(text);
}

export function initSharebarTwitterAndSMSForProjectPage() {
    initSharebarTwitterAndSMS(getProjectTwitterText);
}

function initSharebarTwitterAndSMS(getTwitterTextFunction) {
    setHrefAttributesForSharebarTwitterAndSMS(getTwitterTextFunction);
    $(window).on('userCookiesReset', function () {
        setHrefAttributesForSharebarTwitterAndSMS(getTwitterTextFunction);
    });
}

function getBasicMetadata() {
    const basicMetadata = {};
    basicMetadata.canonical_url = $("link[rel='canonical']").attr('href');
    basicMetadata.description = $("meta[name='description']").attr('content');
    basicMetadata.title = document.getElementsByTagName('title')[0].innerHTML;
    return basicMetadata;
}

function getTwitterMetadata() {
    const twitterMetadata = {};
    twitterMetadata.description = $("meta[name='twitter:description']").attr('content');
    twitterMetadata.card = $("meta[name='twitter:card']").attr('content');
    twitterMetadata.title = $("meta[name='twitter:title']").attr('content');
    twitterMetadata.site = $("meta[name='twitter:site']").attr('content');
    // Even though they are in the html <head>, I left these out because branch.io's endpoint doesn't care about these attributes
    // twitterMetadata["name"] = $("meta[name='twitter:name']").attr("content");
    // twitterMetadata["creator"] = $("meta[name='twitter:creator']").attr("content");
    // twitterMetadata["domain"] = $("meta[name='twitter:creator']").attr("content");
    return twitterMetadata;
}

export function redirectToTwitterWithShortenedUrl(fullUrl, longShareUrl) {
    const requestData = {};
    requestData.url = longShareUrl;
    requestData.basic_metadata = getBasicMetadata();
    requestData.twitter_metadata = getTwitterMetadata();
    getShortenedUrlAndRedirect(fullUrl, longShareUrl, requestData);
}

export function redirectToSmsWithShortenedUrl(fullUrl, longShareUrl) {
    const requestData = {};
    requestData.url = longShareUrl;
    requestData.basic_metadata = getBasicMetadata();
    getShortenedUrlAndDeepLinkToSms(fullUrl, longShareUrl, requestData);
}

function getShortenedUrlAndDeepLinkToSms(fullUrl, longShareUrl, requestData) {
    const newWindow = window.open('', '_blank');
    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/common/shorten.html',
        data: JSON.stringify(requestData),
        dataType: 'json',
        timeout: 1500,
        success: function (data) {
            let smsShareUrl = fullUrl;
            if (data.hasOwnProperty('short')) {
                const shortShareUrl = data.short;
                if (shortShareUrl) {
                    smsShareUrl = fullUrl.replace(longShareUrl, shortShareUrl);
                }
            }
            newWindow.location.href = (new Uri(smsShareUrl)).toString();
        },
        error: function () {
            // Timeout also ends up here
            newWindow.location.href = (new Uri(fullUrl)).toString();
        },
    });
}

// Should work with any redirect, where the share url is a URL param, but must ensure the param name (e.g. "url") is correct
function getShortenedUrlAndRedirect(fullUrl, longShareUrl, requestData) {
    const newWindow = window.open('', '_blank');
    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/common/shorten.html',
        data: JSON.stringify(requestData),
        dataType: 'json',
        timeout: 1500,
        success: function (data) {
            let socialMediaShareUrl = longShareUrl;
            if (data.hasOwnProperty('short')) {
                const shortShareUrl = data.short;
                if (shortShareUrl) {
                    socialMediaShareUrl = shortShareUrl;
                }
            }
            newWindow.location.href = (new Uri(fullUrl)).replaceQueryParam('url', socialMediaShareUrl).toString();
        },
        error: function () {
            // Timeout also ends up here
            newWindow.location.href = (new Uri(fullUrl)).replaceQueryParam('url', longShareUrl).toString();
        },
    });
}

function setHrefAttributesForSharebarTwitterAndSMS(getTwitterTextFunction) {
    let options = { isUserTheTeacher: isUserTheTeacher() };
    const twitterText = decodeURIComponent(getTwitterTextFunction(options));
    let href = $('.js-share-twitter').attr('href');
    const uri = new Uri(href).replaceQueryParam('text', twitterText);
    $('.js-share-twitter').attr('href', uri.toString());

    options = { isUserTheTeacher: isUserTheTeacher(), stripHandle: true };
    const smsText = decodeURIComponent(getTwitterTextFunction(options));
    href = $('.js-share-sms').attr('href'); // contains both sms text and link
    const prefix = href && href.substring(0, href.indexOf('body=') + 5);
    const suffix = href && decodeURIComponent(href.substring(href.indexOf('http')));
    $('.js-share-sms').attr('href', prefix + encodeURIComponent(smsText + suffix));
}
